<template>
    <div class="page-warpper" ref="info">
        <header-modular :url="web_emof_home"></header-modular>
        <div class="container">
            <div class="page-nav flex align-center justify-between margin-top-sm">
                <div class="flex align-center">
                    <div class="page-nav margin-right-xs">您现在的位置：{{title}}</div>
                </div>
                <div>欢迎{{userInfo.company}}登录会员中心</div>
            </div>
            <div class="page-container flex flex-sub">
                <menu-modular :navIndex="navIndex"></menu-modular>
                <div class="content-container">
                    <router-view @setIndex="getIndex(arguments)" class="content"></router-view>
                </div>
            </div>
        </div>
        <footer-modular></footer-modular>
    </div>
</template>

<script>
    import HeaderModular from "./components/HeaderModular.vue";
    import FooterModular from "@/components/FooterModular.vue";
    import MenuModular from "./components/MenuModular.vue";
    import {web_emof_home} from '@/utils/const'
    import {userInfo} from '@/api/member'
    export default {
        name: "Home",
        components: {
            MenuModular,
            FooterModular, HeaderModular
        },
        data() {
            return {
                navIndex: 0,
                title: '',
                userInfo: '',
                web_emof_home: web_emof_home,
            }
        },
        created() {
            this.init()
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        methods: {
            async init() {
                let _data = await userInfo()
                if (_data.status === 200) {
                    this.userInfo = _data.data
                }
            },
            getIndex(data) {
                this.navIndex = data[0]
                this.title = data[1]
                this.scrollTo()
            },
            toPage(url) {
                this.$router.replace(url)
            },
            scrollTo(){
                this.$nextTick(() => {
                    this.$refs.info.scrollTo(0, 0);
                });
            }
        }

    }
</script>

<style scoped lang="scss">
    .page-warpper {
        height: 100vh;
        background: #ebeff5;
        overflow-y: scroll;
        .container {
            display: flex;
            flex-direction: column;
            width: 1200px;
            margin: 0 auto;
            .page-nav {
                font-size: 16px;
                color: #0a2240;
            }
            .page-container {
                margin: 15px 0;
                .content-container {
                    display: flex;
                    flex-direction: column;
                    width:calc(100% - 180px);
                    background-color: #0a2240;
                    border-radius: 10px;
                    padding: 20px;
                    margin-left: 10px;
                    .content {
                        display: flex;
                        flex-direction: column;
                        flex: 1;
                    }
                }
            }

        }

    }
</style>